/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import './buttons.css'

const Buttons = (props: any) => {
  return (
    <button
      aria-label={props['aria-label'] || props?.label}
      className={`btn ${props?.className}`}
      onClick={props?.onClick}
      tabIndex={0}
      title={props['aria-label'] || props?.label}
      type={props?.type || 'button'}
      value={props?.showhide}
    >
      {props?.icon && <span className={`${props?.icon}`}></span>} {props?.label}{' '}
      {props?.rIcon && <span className={`${props?.rIcon}`}></span>}
      {props?.isInfo && (
        <span className={props?.infoClassName} data-tip={props?.info}>
          <span className={props?.infoIcon}></span>
        </span>
      )}
    </button>
  )
}
export default Buttons
